module.exports = __webpack_public_path__ + "img/slideshow3.7c05185e.png";